module.exports = "/shared/img/virtual-football-league.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/virtual-football-league.png
// module id = 458
// module chunks = 13